// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimV1ClaimAccumulatorSearchAccumulatorSearchRequest {
    static getAttributeTypeMap() {
        return ClaimV1ClaimAccumulatorSearchAccumulatorSearchRequest.attributeTypeMap;
    }
}
ClaimV1ClaimAccumulatorSearchAccumulatorSearchRequest.discriminator = undefined;
ClaimV1ClaimAccumulatorSearchAccumulatorSearchRequest.additionalProperties = false;
ClaimV1ClaimAccumulatorSearchAccumulatorSearchRequest.attributeTypeMap = [
    {
        "name": "start",
        "baseName": "start",
        "type": "number"
    },
    {
        "name": "pageSize",
        "baseName": "pageSize",
        "type": "number"
    },
    {
        "name": "memberNumbers",
        "baseName": "memberNumbers",
        "type": "Array<string>"
    },
];
//# sourceMappingURL=claimV1ClaimAccumulatorSearchAccumulatorSearchRequest.js.map